/**
 * 阻止事件冒泡
 * @param event
 */
export const stopPropagation = (event: Event) => event.stopPropagation();

/**
 * 阻止默认行为
 * @param event
 * @param isStopPropagation
 */
export function preventDefault(event: Event, isStopPropagation?: boolean) {
  /* istanbul ignore else */
  if (typeof event.cancelable !== 'boolean' || event.cancelable) {
    event.preventDefault();
  }

  if (isStopPropagation) {
    stopPropagation(event);
  }
}
